import { render, staticRenderFns } from "./BetgameEditBetview.vue?vue&type=template&id=1d48c0a2&scoped=true"
import script from "./BetgameEditBetview.vue?vue&type=script&lang=js"
export * from "./BetgameEditBetview.vue?vue&type=script&lang=js"
import style0 from "./BetgameEditBetview.vue?vue&type=style&index=0&id=1d48c0a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d48c0a2",
  null
  
)

export default component.exports